import { EditionAwarenessContextType } from './edition-awareness-context';

type StandardTrialsUserAndStorageLimitBreakersExperimentEligibility = {
	context: EditionAwarenessContextType;
};

export function isEligibleForStandardTrialsUserAndStorageLimitBreakers({
	context,
}: StandardTrialsUserAndStorageLimitBreakersExperimentEligibility): boolean {
	const {
		config: { isStandardTrialsUserAndStorageLimitBreakersEnabled },
		product,
		isInTrial,
		isInPredunning,
		isInvoiceable,
		licensedUsers,
		canAddPaymentDetails,
		trialDaysLeft,
		storageUsageInGB,
	} = context;

	const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
	const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
	const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);

	if (product === 'confluence') {
		return !!(
			isStandardTrialsUserAndStorageLimitBreakersEnabled &&
			(isInTrial || isInPredunning) &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	if (product === 'jira') {
		return !!(
			isStandardTrialsUserAndStorageLimitBreakersEnabled &&
			isInTrial &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	return false;
}
